import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faSort } from '@fortawesome/free-solid-svg-icons';

const SortIndicator = ({ field, sortConfig }) => {
    const isActive = sortConfig?.field === field;

    if (!isActive) {
        return (
            <span className="sort-indicator sort-indicator--idle">
                <FontAwesomeIcon icon={faSort} />
            </span>
        );
    }

    return (
        <span className="sort-indicator sort-indicator--active">
            <FontAwesomeIcon icon={sortConfig.direction === 'asc' ? faSortUp : faSortDown} />
        </span>
    );
};

export default SortIndicator;
